import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import './history.css'

export default class History extends Component {
    historyColumns = [
        { title: 'Дата', field: 'date' },
        { title: 'Пользователь', field: 'userName' },
        { title: 'Поле', field: 'field' },
        { title: 'Старое значение', field: 'oldValue' },
        { title: 'Новое значение', field: 'newValue' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            history: [],
            isInLoading: false
        };
    }

    componentDidMount() {
        if (!this.props.workId) return;
        var scope = this;
        this.setState({ isInLoading: true });
        fetch('api/Work/GetHistory?workId=' + this.props.workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ history: result, isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        var history = this.state.history && this.state.history.map && this.state.history.map(h => <div>{h.userName} изменил/а {h.field} с {h.oldValue} на {h.newValue}</div>);
        if (!this.props) {
            return <div></div>
        }
        return (
            <MaterialTable
                title=""
                columns={this.historyColumns}
                
                data={this.state.history}
                editable={{
                }}
                actions={[
                ]}
            />
        );
    }
}
